<script lang="ts">
	import {ASSET_URL} from "../config";

	export let customClass = "";
</script>

<div class="info-box {customClass}">
 	<div class="info-icon"><img src="{ASSET_URL}/assets/img/icons/info-icon.svg"/></div>
	<div class="info-content">
		<slot></slot>
	</div>
</div>

<style lang="scss">

	.info-box{

		display:flex;
		background:$secondary-color;
		color:white;
		padding:1rem;
		border-radius:9px;

	}
	.info-icon{
		width:25px;
		margin-right:0.75rem;
		flex-shrink: 0;

		img{
			width:100%;
			height:auto;
		}
	}
	.info-content{


	}

</style>
